<template>
  <div v-if="show" class="status-dialog">
    <div class="status-dialog-mask"></div>
    <div class="status-dialog-content">
      <i v-if="type === 'error'" @click="hideDialog" class="ws-icon-close close-btn"></i>
      <span class="mr-24 tf-y-4">
        <img v-if="type === 'loading'" class="icon-img" src="@/assets/images/bars.svg" alt="loading"/>
        <i v-else-if="type === 'success'" class="icon-inner text-color-success ws-icon-check-circle"></i>
        <i v-else-if="type === 'error'" class="icon-inner text-color-error ws-icon-close-circle"></i>
      </span>
      <span>{{msg}}</span>
    </div>
  </div>
</template>
<script setup>
import { toRefs } from 'vue'
const props  = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'loading' // loading, success, error
  },
  msg: {
    type: String,
    default: '处理中...'
  }
})

const emit = defineEmits(['update:show'])
const { show, type } = toRefs(props)

const hideDialog = () => {
  emit('update:show', false)
}



</script>
<style lang="scss">
.status-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  .status-dialog-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .status-dialog-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    z-index: 1001;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    width:420px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .close-btn{
      position: absolute;
      top:10px;
      right:20px;
    }
    .icon-img{
      width:40px;
    }
    .icon-inner{
      font-size: 36px;
    }
  }
}
</style>